import {
  apiGetGiftList,
  apiGetGiftListPackage,
  apiGiftSend,
  apiGiftSendMulti
} from '@/api/gift'
import type {
  giftInterface,
  giftSendRequestInterface,
  giftSendMultiRequestInterface
} from '@/types/apiType/giftType'

export const useGiftStore = defineStore({
  id: 'gift',
  state: () => ({
    giftVersion: 0 as number, // 礼物接口版本
    giftList: [] as giftInterface[], // 礼物列表
    giftTypeList: [
      {
        type: 2,
        label: 'gift.General',
        gifts: [] as giftInterface[]
      },
      {
        type: 6,
        label: 'gift.Lucky',
        gifts: [] as giftInterface[]
      },
      {
        type: 9,
        label: 'gift.Celebrity',
        gifts: [] as giftInterface[]
      },
      {
        type: 11,
        label: 'gift.Country',
        gifts: [] as giftInterface[]
      },
      {
        type: 3,
        label: 'gift.Package',
        gifts: [] as giftInterface[]
      },
      {
        type: 10,
        label: 'gift.VIP',
        gifts: [] as giftInterface[]
      }
    ], // 礼物类型
    lastTime: 0 // 上次获取礼物接口的时间，超过一小时就获取一次
  }),
  actions: {
    /**
     * 礼物赠送
     * @param {number} type '赠送礼物类型：1，赠送给房主；2，私聊发礼物；3，房间内赠送给个人；6，动态送礼 7，主播送礼'
     * @param {number} targetUid '收礼用户ID'
     * @param {number} giftId '礼物ID'
     * @param {number} giftNum '礼物数量'
     * */
    async giftSend(
      params: {
        type: 1 | 2 | 3
        targetUid: number
        giftId: number
        giftNum: number
      },
      giftInfo: giftInterface
    ) {
      const roomStore = useRoomStore()
      const userStore = useUserStore()
      const data = {
        appVersion: '',
        comboCount: 0,
        comboFrequencyCount: 0,
        comboId: 0,
        os: 'web',
        sn: '',
        expressMessage: '',
        giftId: params.giftId,
        giftNum: params.giftNum,
        momentId: 0,
        roomType: 0,
        roomId: 0,
        roomUid: 0,
        targetUid: params.targetUid,
        type: params.type
      } as giftSendRequestInterface
      // 送给房主
      if (params.type === 1 || params.type === 3) {
        data.roomType =
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL_SHORT
            ? 10
            : roomStore.roomType
        data.roomId = roomStore.roomId
        data.roomUid = roomStore.roomUid
        data.targetUid = roomStore.roomUid
      }
      console.log(data.targetUid, data.giftId, data.giftNum)
      if (!data.targetUid || !data.giftId || !data.giftNum) return

      const res = await apiGiftSend(data)
      const { code, data: giftData } = res
      if (code === 200) {
        userStore.requestUserInfo()
        if (giftInfo.giftType === 6) {
          this.getGiftListPackage()
        }
        return Promise.resolve(giftData)
      }
      // 显示余额不足弹窗
      if (code === 2103) {
        const publicStore = usePublicStore()
        publicStore.setShowRechargePopup(true)
      } else {
        res.message && showToast(res.message)
      }

      return
    },
    /**
     * 多人礼物赠送
     * @param {string} targetUids '多个收礼用户ID'
     * @param {number} giftId '礼物ID'
     * @param {number} giftNum '礼物数量'
     * */
    async giftSendMulti(
      params: {
        targetUids: string
        giftId: number
        giftNum: number
      },
      giftInfo: giftInterface
    ) {
      const roomStore = useRoomStore()
      const userStore = useUserStore()
      const data = {
        appVersion: '',
        comboCount: 0,
        comboFrequencyCount: 0,
        comboId: 0,
        os: 'web',
        sn: '',
        giftId: params.giftId,
        giftNum: params.giftNum,
        momentId: 0,
        roomType: 0,
        roomId: 0,
        roomUid: 0,
        targetUids: params.targetUids
      } as giftSendMultiRequestInterface
      data.roomType = roomStore.roomType as 0 | 3 | 5 | 6 | 7 | 8 | 10
      data.roomId = roomStore.roomId
      data.roomUid = roomStore.roomUid
      if (!data.targetUids || !data.giftId || !data.giftNum) return
      const res = await apiGiftSendMulti(data)
      const { code, data: giftData } = res
      if (code === 200) {
        userStore.requestUserInfo()
        if (giftInfo.giftType === 6) {
          this.getGiftListPackage()
        }
        return Promise.resolve(giftData)
      }
      // 显示余额不足弹窗
      if (code === 2103) {
        const publicStore = usePublicStore()
        publicStore.setShowRechargePopup(true)
      } else {
        res.message && showToast(res.message)
      }

      return
    },
    // 获取礼物列表,用户礼物列表
    getGiftList() {
      const nowTime = new Date().getTime() // 现在的时间
      // 没数据，或者和上次获取的时间超过一小时就获取 3600000
      if (
        this.giftList.length === 0 ||
        this.lastTime === 0 ||
        nowTime >= this.lastTime + 3600000
      ) {
        apiGetGiftList({
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line no-undef
          appVersion: '',
          giftScreen: 0,
          giftVersion: this.giftVersion
        }).then((res) => {
          const { code, data } = res
          if (code === 200) {
            this.giftVersion = data.newestGiftVersion
            if (data.gift) {
              // 过滤
              const temporaryGiftTypeInfo = {
                2: [],
                6: [],
                9: [],
                11: [],
                10: []
              }
              this.giftList = data.gift
              this.lastTime = nowTime // 赋值刷新接口的时间
              //分类
              data.gift.forEach((v) => {
                // 过滤图片
                v.giftUrl = common.handlePicUrlGift(v.giftUrl)

                if (temporaryGiftTypeInfo[v.giftType]) {
                  temporaryGiftTypeInfo[v.giftType].push(v)
                }
              })
              this.giftTypeList.forEach((v) => {
                if (temporaryGiftTypeInfo[v.type]) {
                  v.gifts = temporaryGiftTypeInfo[v.type] as giftInterface[]
                }
              })
            }
          }
        })
      }
    },
    //获取背包礼物列表
    async getGiftListPackage() {
      const { code, data } = await apiGetGiftListPackage({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-undef
        appVersion: '',
        app: 'olamet',
        giftVersion: 0,
        os: 'web',
        sn: ''
      })
      let dataList: giftInterface[] = []
      if (code === 200) {
        dataList = data.map((v) => {
          v.gifUrl = common.handlePicUrlGift(v.giftUrl)
          return v
        })
        this.giftTypeList[4].gifts = dataList as giftInterface[]
      }
      return Promise.resolve(dataList || [])
    },
    // 重置数据
    resetData() {
      this.giftList = []
      this.giftVersion = 0
      this.lastTime = 0
      this.giftTypeList = [
        {
          type: 2,
          label: 'gift.General',
          gifts: [] as giftInterface[]
        },
        {
          type: 6,
          label: 'gift.Lucky',
          gifts: [] as giftInterface[]
        },
        {
          type: 9,
          label: 'gift.Celebrity',
          gifts: [] as giftInterface[]
        },
        {
          type: 11,
          label: 'gift.Country',
          gifts: [] as giftInterface[]
        },
        {
          type: 3,
          label: 'gift.Package',
          gifts: [] as giftInterface[]
        },
        {
          type: 10,
          label: 'gift.VIP',
          gifts: [] as giftInterface[]
        }
      ]
    }
  },
  persist: {
    key: 'giftStore',
    paths: ['giftList', 'giftVersion', 'giftTypeList', 'lastTime']
  }
})
